<template>
  <div v-if="$store.state.window < 1100 " id="sidebar-account">
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        width="auto"
      >
        <transition v-if="$store.state.window < 1100" name="slide-fade">
          <welcome-menu @close="$store.state.welcomeMenu = false"/>
        </transition>
<!--        <transition v-if="$store.state.window < 1100" name="slide-fade">-->
<!--          <div :class="[this.$lang === 'ar' ? 'left-side' : 'right-side', 'triangle border-white-1-50']" v-if="dialogs[3].value"></div>-->
<!--        </transition>-->
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import WelcomeMenu from '@/components/Menus/WelcomeMenu'
import utils from '@/shared/utils'
import $ from 'jquery'
export default {
  components: { WelcomeMenu },
  data () {
    return {
      reverseDialog: utils.changeDialogStatus,
      dialogs: utils.dialogs,
      dialog: true
    }
  },
  mounted () {
    $('.v-dialog__content.v-dialog__content--active').css('z-index', '10000000')
    $('.v-dialog__content.v-dialog__content--active').css('backdrop-filter', 'blur(10px)')
  }
}
</script>
